<template>
  <v-content class="login page">
    <v-container>
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card raised class="mt-3">

            <v-toolbar card :color="themes.candidate.light.dialogTitle">
              <v-toolbar-title class="headline">Log in</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <Login @done="$router.push('/dashboard')" />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes.js'

// Components
import Login from '@/components/Login.vue'

export default {
  mixins: [managedDocumentAttributes],

  components: { Login },

  created() {
    this.documentAttributes.title = 'Login - Leaply'
    if (this.$route.hash === '#signup') this.$emit('signup')
  },
}
</script>
